import assign from 'lodash/assign';
import orderBy from 'lodash/orderBy';
import uiRouter from '@uirouter/angularjs';

import { CategoryServiceModule } from 'services/data/categories.service';
import { ProductServiceModule } from 'services/data/products.service';
import { PagesServiceModule } from 'services/data/pages.service';
import { LaunchDarklyServiceModule } from 'services/access/launchDarkly/launchDarkly.service';
import { AuthTokenServiceModule } from 'services/auth/authToken.service';
import { StoreInformationServiceModule } from 'services/data/storeInformation.service';
import SiteDesignerService from 'admin/services/api/SiteDesigner';

import template from './selectItem.html';
import './selectItem.scss';

import menuConstants from './menuConstants';

const PRODUCT_LIMIT = 200;
const GENEROUS_PAGE_SIZE = 1000;
const FIRST_PAGE = 1;
const dynamicPageOr404 = /\/:|(^\/404$)|(^\/search)/;

export const SelectItem = angular
    .module('app.pages.editstore.menuEditor.selectItem', [
        CategoryServiceModule,
        ProductServiceModule,
        PagesServiceModule,
        LaunchDarklyServiceModule,
        AuthTokenServiceModule,
        StoreInformationServiceModule,
        uiRouter
    ]).component('menuEditorSelectItem', {
        template,
        bindings: {
            onBackButtonClick: '<',
            onMenuItemSelected: '<',
            onAddItemClick: '<',
            type: '<'
        },
        controller: class MenuEditorSelectItemCtrl {
            constructor(
                categoryService,
                productService,
                pagesService,
                launchDarklyService,
                authTokenService,
                storeInformationService,
                $rootScope,
                $state,
                $q
            ) {
                'ngInject';

                assign(this, {
                    dataItems: [],
                    linkData: {},
                    urlData: {},
                    loading: true,
                    categoryService,
                    productService,
                    pagesService,
                    launchDarklyService,
                    authTokenService,
                    storeInformationService,
                    $rootScope,
                    $state,
                    $q,
                    TYPES: menuConstants.TYPES,
                    showAddItemLink: true
                });
            }

            $onInit() {
                if (this.type === menuConstants.TYPES.CATEGORY) {
                    this.categoryService.getCategories(true)
                        .then(data => this.sort(data))
                        .then(data => this.onDataResponse(data));
                } else if (this.type === menuConstants.TYPES.PRODUCT) {
                    this.productService.getMinimalProducts(
                        FIRST_PAGE,
                        PRODUCT_LIMIT,
                        ['name asc'],
                        { filter: 'state eq "Active"', include: 'seo' }
                    )
                        .then(data => this.sort(data))
                        .then(data => this.onDataResponse(data));
                } else if (this.type === menuConstants.TYPES.PAGE) {
                    this.authTokenService.getBearer().then((token) => {
                        SiteDesignerService.setAuthToken(token);

                        const SiteDesignerPagesPromise = SiteDesignerService.getInstalledTheme()
                            .then(theme => theme.id)
                            .then(themeId => SiteDesignerService.getPages(themeId))
                            .then(pages => pages.filter(page => !page.path.match(dynamicPageOr404)));

                        this.storeInformationService.getStore()
                            .then(storeInformation => this.$q.all([
                                this.pagesService.getPages(null, null, { pageSize: GENEROUS_PAGE_SIZE }),
                                SiteDesignerPagesPromise,
                                this.launchDarklyService.isNewAccount(storeInformation)
                            ]))
                            .then(([pages, elementPages, newAccount]) => {
                                this.showAddItemLink = !newAccount;
                                const normalizedElementPages = elementPages.map((page) => {
                                    return {
                                        type: menuConstants.TYPES.ELEMENT_PAGE,
                                        name: page.title,
                                        createdOn: page.auditInfo.createdOn,
                                        updatedOn: page.auditInfo.updatedOn,
                                        path: page.path,
                                        seo: {}
                                    };
                                });
                                return newAccount ?
                                    normalizedElementPages :
                                    [...pages.items, ...normalizedElementPages];
                            })
                            .then(pages => this.sort(pages))
                            .then(data => this.onDataResponse(data))
                            .catch((err) => {
                                // eslint-disable-next-line no-console
                                console.error(`Problem getting pages: ${err}`);
                                this.onDataResponse([]);
                            });
                    });
                }
            }

            onDataResponse(data) {
                this.dataItems = data;
                this.loading = false;
            }

            sort(data) {
                if (this.type === menuConstants.TYPES.CATEGORY) {
                    return orderBy(data, ['createdOn'], ['desc']);
                }

                if (this.type === menuConstants.TYPES.PRODUCT) {
                    return orderBy(data.items, ['updatedOn'], ['desc']);
                }

                if (this.type === menuConstants.TYPES.PAGE) {
                    return orderBy(data, ['updatedOn'], ['desc']);
                }

                return data;
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/menuEditor/selectItem.js